import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import { useLocation, useNavigate } from 'react-router';
import { Button } from '@mui/material';
import { StaffGet } from '../../../api/orgService';
import useApi from '../../../api/useApi';
import { toast } from 'react-toastify';
import SkeletonList from '../../sections/SkeletonList';


function StaffAdminList() {

    const navigate = useNavigate()
    const location = useLocation()
    const [AllStaff,setAllStaff] =useState([])
    const [remappedData,setRemaappedData] =useState([])
    // const [nextPageUrl, setNextPageUrl] = useState('http://localhost:8000/api/articles/');
    const [loading, setLoading] = useState(false);

    const { request: getAllStaff, data:staffData, error:staffError, isLoading:getStaffIsLoading} = useApi(StaffGet);

          useEffect(() => {
            getAllStaff();
                 // eslint-disable-next-line
            }, []);
            
            useEffect(()=>{
              if (staffData?.status===200) {
                setAllStaff(staffData?.data);
              }
            // eslint-disable-next-line
            },[staffData])

            useEffect(()=>{
              if(AllStaff?.results){
              const row = AllStaff?.results?.map((item, index) => ({
                id: index + 1,
                StaffId:item.id,
                staff_email: item.staff_email,
                first_name: item.staff_user?.first_name || '',
                last_name: item.staff_user?.last_name || '',
                middle_name: item.staff_user?.middle_name || '',
                email: item.staff_user?.email || '',
                username: item.staff_user?.username || '',
                title: item.title,
                staff_status: item.staff_status,
                is_active_staff: item.is_active_staff,
                is_suspended: item.is_suspended,
                created_at: item.created_at,
              }));

              setRemaappedData(row)

            }
            },[AllStaff?.results])
    
          
            // useEffect(()=>{
            //     if(location?.state?.refresh==="org"){
            //       getAllStaff();
            //     }
            //   // eslint-disable-next-line
            //   },[location?.state])
          
            useEffect(()=>{
                if(staffError){
                    toast.error(`${JSON.stringify(staffError?.response?.data,null,2)}`,{position: "top-center"});
              }
            },[staffError]) 


    const rows = [
        { id: 1, name: 'Fountain Africa Org', description: 'the Community version', link: "/staff/organisation/detail"},
        { id: 2, name: 'Data Grid Pro', description: 'the Pro version', link: "/staff/organisation/detail?id=1" },
        { id: 3, name: 'Data Grid Premium', description: 'the Premium version', link: "/staff/organisation/detail?id=1" },
      ];

      // {
      //   "staff_email": null,
      //   "staff_user": {
      //     "email": "teststaff1@gmail.com",
      //     "first_name": "Staff",
      //     "last_name": "One",
      //     "middle_name": "One",
      //     "username": "staffone",
      //     "created_at": "2025-10-21T00:01:32.752748+03:00"
      //   },
      //   "title": "",
      //   "org": 1,
      //   "is_active_staff": true,
      //   "is_suspended": false,
      //   "staff_status": "active",
      //   "created_at": "2025-10-21T00:01:32.775172+03:00",
      //   "updated_at": "2025-10-21T00:01:32.775227+03:00"
      // }
      
    const columns = [
        { field: 'id', headerName: 'SN Number', width: 200 },
        { field: 'staff_email', headerName: 'Staff Email', width: 200 },
        { field: 'first_name', headerName: 'First Name', width: 300 },
        { field: 'last_name', headerName: 'Last Name', width: 300 },
        { field: 'link', headerName: 'View Details', width: 300,
            renderCell: (params) => (
                // <Link
                //   href={params.value}
                //   style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
                // >
                //   View details →
                // </Link>
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => navigate(`/staff/profile/detail/${params.row.StaffId}/`, {state: { staffId: params.row.StaffId, staffName: params.row.staff_email }})}
                    sx={{
                    textTransform: 'none',
                    backgroundColor: '#1976d2',
                    '&:hover': { backgroundColor: '#115293' },
                    }}
                >
                    View Details
                </Button>
              ),
         }
    
      ];
    
      console.log(remappedData)

    if(getStaffIsLoading){
      return (
        <SkeletonList/>
      )
    }

  return (
    <div style={{ height: '80%', width: '100%' }}>
      <DataGrid rows={remappedData} columns={columns} />
    </div>
  )
}

export default StaffAdminList